import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";

import ConsultaInterCompany from '../../../../lib/json/consultas/InterCompany.json'

import LoadingSpinner from "../../../components/LoadinSpinner";
import InputGeral from "../../../components/InputGeral/Index";
import { useNavigate, useParams } from "react-router-dom";
import SubmitForm from "../../../components/SubmitForm";
import { ErroMsg, SucessoMsg } from "../../../contents/VariaveisGlobais";
import { toast } from "react-toastify";
import ConsumoTOTVS_POST from "../../../../backend/ConsumoTotvs";
import TitlePageTotvs from "../../../components/TitlePageTotvs";
import { ConsultaTotvsEmpresa } from "../../../../backend/ConsultaTotvsEmpresa";
import SelectContaContabil from "../../../components/Select/ContaContabil";
import SelectDinamico from "../../../components/SelectDinamico";

function FichaInterCompany(){
    const navigate = useNavigate();
    const isFormVisual = window.location.href.includes('Visualizar');
    
    // define a exibição do Loading
    var [carregar, setCarregar] = useState(false);
    const [disabledForm, setDisabledForm] = useState(isFormVisual);

    const { idInterCompany, empresaFilialBMSI } = useParams();
    
    const [empresaFilialSelect, setEmpresaFilialSelect] = useState(empresaFilialBMSI);
    const [empresaFilial, setEmpresaFilial] = useState(empresaFilialBMSI);

    // Consulta do grid
    var consultaDefault  = ConsultaInterCompany.consulta + (idInterCompany ? ` AND PZ3_ID = '${idInterCompany}'` : '');
    
    const cConsulta = "SELECT RTRIM(XX8_EMPR) + RTRIM(XX8_GRPEMP) EMPRESA, XX8_DESCRI NOME FROM SYS_COMPANY_CFG XX8 WHERE XX8_TIPO = '2' AND XX8.D_E_L_E_T_ <> '*'"
    const cTabelas = "XX8"

    const [campoCodigo, setCampoCodigo]   = useState('0');
    const [campoEmpresa, setCampoEmpresa] = useState({value: '', label: 'Selecione o Empresa'});
    const [campoCredito, setCampoCredito] = useState({value: '', label: 'Selecione a Conta Contábil'});
    const [campoDebito, setCampoDebito]   = useState({value: '', label: 'Selecione a Conta Contábil'});
    
    useEffect(() => {
        if (idInterCompany){
            loadInterCompany();
        }
    }, []);

    // Processa consulta do grid
    const loadInterCompany = async () => {
        setCarregar(true);
        
        var retConsulta = await ConsultaTotvsEmpresa( consultaDefault, ConsultaInterCompany.tabelas, empresaFilial.substr(0,window._env_?.REACT_APP_TAMANHO_EMPRESA) + '-' + empresaFilial.substr(-window._env_?.REACT_APP_TAMANHO_FILIAL) );
        
        if (retConsulta.data){
            const {PZ3_ID, PZ3_EMPRES, NOMEINTER, PZ3_CONTCR, PZ3_CONTDE } = retConsulta.data[0]
            setCampoCodigo(PZ3_ID);
            setCampoEmpresa({value: PZ3_EMPRES, label: NOMEINTER});
            setCampoCredito({value: PZ3_CONTCR, label: ''});
            setCampoDebito({value: PZ3_CONTDE, label: ''});
        }
        
        setCarregar(false);
    }

    const handleSalvar = async() =>{
        // Verificar se todos os campos obrigatórios foram preenchidos
        if (!campoEmpresa?.value) {
            toast.warning('O prenchimento do campo é obrigatório.');
            return;
        }

        const cJSON = { 
            ACAO: idInterCompany ? 'ALTERAR' : 'INCLUIR',
            PZ3_ID: campoCodigo,
            PZ3_EMPRES: campoEmpresa.value,
            PZ3_CONTCR: campoCredito.value,
            PZ3_CONTDE: campoDebito.value,
        }

        setCarregar(true);
        const oRetorno = await ConsumoTOTVS_POST('INTERCOMPANY', cJSON, empresaFilial)

        if (oRetorno.error === '00'){
            SucessoMsg(oRetorno.description)
        }else{
            ErroMsg(oRetorno.description)
            return false;
        }
        
        return true;
    }

    const handleEmpresaFilial = (e) => {
        setEmpresaFilialSelect(e)
        setEmpresaFilial(e.value)
    }

    return (
        <>
            <Row>
                <LoadingSpinner isLoading={carregar}/>
                <Col md="12" xs="12">
                    <TitlePageTotvs 
                        text="Empresas x Conta Contábil" 
                        empresa={empresaFilialSelect} 
                        empresaFilial={empresaFilial} 
                        changeEmpresa={handleEmpresaFilial}
                    />
                </Col>
            </Row>
            { empresaFilial &&
                <>
                    <Row>
                        <Col md="2" xs="12">
                            <InputGeral 
                                label="Código"
                                tipo='text'
                                value={campoCodigo}  // Define o valor do campo com base no estado
                                onChange={(e) => setCampoCodigo(e.target.value)}
                                disabled={!idInterCompany || disabledForm }                    
                            />
                        </Col>

                        <Col md="4" xs="12">
                            <SelectDinamico
                                campoValue={campoEmpresa}
                                onchange={(e) => setCampoEmpresa(e)}
                                EmpresaLogada={empresaFilial}
                                cText={"NOME"}
                                cValue={"EMPRESA"}
                                consulta={cConsulta}
                                tabela={cTabelas}
                                label={"Empresa Origem"}
                                disabled={disabledForm}
                            />
                        </Col>                        
                    </Row>
                    <Row>
                        <Col md="6" xs="12">
                            <SelectContaContabil 
                                empresaLogada={empresaFilial}
                                label="Crédito"
                                campoContaContabil={campoCredito}  // Define o valor do campo com base no estado
                                changeContaContabil={setCampoCredito}
                                disabled={disabledForm}
                            />
                        </Col>
                        <Col md="6" xs="12">
                            <SelectContaContabil 
                                empresaLogada={empresaFilial}
                                label="Débito"
                                campoContaContabil={campoDebito}  // Define o valor do campo com base no estado
                                changeContaContabil={setCampoDebito}
                                disabled={disabledForm}
                            />
                        </Col>
                    </Row>                    
                </>
            }
            
            <SubmitForm 
                onSave={ disabledForm ? null : handleSalvar}
                onCancel={ disabledForm ? null : "handleCancelar"}
                onVoltar={ disabledForm ? "handleVoltar" : null}
            />
        </>
    );
}

export default FichaInterCompany;